module.exports = __webpack_public_path__ + "img/iroasumizu.e77112ec.jpg";